// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__yldCx","inner":"Footer_inner__1Fjvz"};